"use strict";

(function (Drupal, once) {
  Drupal.behaviors.search = {
    attach: function attach(context, settings) {
      var searchTriggers = document.querySelectorAll('.search--trigger');
      if (!searchTriggers.length) {
        return;
      }
      var utils = Drupal.behaviors.dart_utils;
      var body = document.body;
      var overlay = document.querySelector('.search--overlay');
      var header = document.querySelector('.header--wrapper');
      var announcement = document.querySelector('article.announcement');
      var announcementHeight = announcement ? announcement.offsetHeight : 0;
      var classes = {
        overlay: 'js-search-overlay-active',
        scrolled: 'js-is-scrolled'
      };

      /*
       * Toggle the search overlay.
       */
      var searchTriggerHandler = function searchTriggerHandler(callback) {
        if (!body.classList.contains(classes.overlay)) {
          body.classList.add(classes.overlay);
          utils.body_prevent_scroll();
          var offset = parseInt(window.getComputedStyle(body).top);
          if (body.classList.contains(classes.scrolled)) {
            offset += announcementHeight;
          }
          header.style.top = "".concat(Math.abs(offset), "px");
        } else {
          body.classList.remove(classes.overlay);
          header.style.removeProperty('top');
          utils.body_prevent_scroll_destroy();
        }
      };
      once('toggleSearchOverlay', '.search--trigger', context).forEach(function (element) {
        element.addEventListener('click', searchTriggerHandler);
      });
    }
  };
})(Drupal, once);